import React from "react"
import { Button, Modal,
  ModalHeader,
  ModalBody,
  ModalFooter, } from "reactstrap";
import { Plus } from "react-feather";
import classnames from "classnames";
import "../../assets/scss/pages/common.scss";
// import ScheduleMeetingForm from "./components/ScheduleMeetingForm";
import ScheduleMeetingWizard from "./components/ScheduleMeetingWizard";

class AddEventButton extends React.Component {
  state = {
    sliderVisibility: false
  }

  onCreateSuccess = () =>{
    this.setState({sliderVisibility: false});
  }

  toggleSlider = () => {
    this.setState(prevState => ({
      sliderVisibility: !prevState.sliderVisibility
    }))
  }

  
  render(){
    // const modal = (<Modal
    //   isOpen={this.state.sliderVisibility}
    //   toggle={this.toggleModal}
    //   className="modal-dialog-centered modal-xl"
    // >
    //   <ModalBody>
    //     <ScheduleMeetingWizard
    //       onCreateSuccess={this.onCreateSuccess}
    //       toggleSliderVisibility={this.toggleSlider}
    //       meetingId={null} 
    //       newMeetingPage={true}
    //       />
    //   </ModalBody>
    // </Modal>)

  return (
    <React.Fragment>
    <Button
      color="primary"
      onClick={() => {
        this.toggleSlider();
      }}
      className="d-sm-block d-none"
    >
      {" "}
      <Plus size={15} /> <span className="align-middle">Add Meeting</span>
    </Button>
      <div className="animation-slider">
        {
          this.state.sliderVisibility
          ? <ScheduleMeetingWizard
            show={this.state.sliderVisibility}
            onCreateSuccess={this.onCreateSuccess}
            toggleSliderVisibility={this.toggleSlider}
        />
        : null
        }
      <div
          className={classnames("animation-slider-overlay", {
          show: this.state.sliderVisibility
        })}
          onClick={() => this.toggleSlider(false)}
      />
    </div>  
    </React.Fragment>
  )
    }
}

/*export default connect(null, { handleSidebar, handleSelectedEvent })(
  AddEventButton
)*/
export default AddEventButton;
